<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<h5>Validações SCR para solicitações de honra</h5>
<div class="container" *ngIf="valoresPesquisaForm; else carregando">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>    
      
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)"
        [disabled]="!pesquisaForm.valid">Pesquisar</button>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="ehAgenteFinanceiro" id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <ng-container *ngFor="let item of agentesFinanceiros">
            <option *ngIf="item.cnpj == cnpjUsuario" [ngValue]="item">{{ item.nome }}</option>
          </ng-container>
        </select>
        <select *ngIf="!ehAgenteFinanceiro" id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of agentesFinanceiros"
                  [ngValue]="item">{{ item.nome }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataValidacaoInicio">Data de validação inicial:</label>
        <bn-datepicker name="dataValidacaoInicio" idInput="dataEnvioInicio" formControlName="dataValidacaoInicio" >
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
          <label class="form-label" for="dataValidacaoFim">Data de validação final:</label>
          <bn-datepicker name="dataValidacaoFim" idInput="dataEnvioFim" formControlName="dataValidacaoFim">
          </bn-datepicker>
      </div>
      
    </div>

    <div class="mb-3 row">
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="janela">Janela de envio: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Nome da janela de envio em formato Mês/Ano (MM/AAAA)"></i></label>
        <input type="text" class="form-control" bnMask="MESANO" formControlName="janela">
      </div>
      <div class="bn-form-group col-md-2"> 
        <label class="form-label">Id. sol. honra: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador da solicitação de honra"></i>
        </label>
        <input type="text" class="form-control" formControlName="idSolicitacaoHonra">
      </div>
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="status">Status de validação:</label>
        <select [(ngModel)]="statusValidacao" id="status" class="form-select" [compareWith]="compararPorId" formControlName="statusValidacaoOpcoes">
          <option *ngFor="let status of statusValidacaoOpcoes" 
                   [selected]="status.label == 'Todos'">{{ status.label }}</option>
        </select>
      </div>

      <div class="bn-form-group col-md-3">
        <label class="form-label" for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
        </label>
        <select id="sistema" class="form-select" [compareWith]="compararPorId" formControlName="sistema">
          <option value=''>Todos</option>
          <option value='CL'>Crédito Livre</option>
          <option value='15'>15 - Contratos FINAME</option>
          <option value='89'>89 - Contratos BNDES</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
        </label>
        <input type="text" class="form-control" formControlName="idExternoOperacao">
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
        </label>
        <input type="text" class="form-control" formControlName="contrato">
      </div>

      <div class="bn-form-group col-md-4">
        <label class="form-label" for="tipo">Tipo de validação:</label>
        <select id="tipo" class="form-select" [compareWith]="compararPorId" formControlName="tipoValidacao">
          <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.tipoValidacao">Todos exceto envio</option>
          <option *ngFor="let tipoValidacao of tiposValidacao" 
                    [selected]="valoresPesquisaForm && valoresPesquisaForm.tipoValidacao == tipoValidacao.codigo">{{ tipoValidacao.label }}</option>
        </select>
      </div>

      <div class="bn-form-group col-md-3">
        <div class="row">
          <div class="col-md-12">
            <label class="form-label" for="tipo">Excluir validações vazias:</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <input type="radio" value="S" name="excluirValidacoesVazias" formControlName="excluirValidacoesVazias"> Sim
          </div>
          <div class="col-md-6">
            <input type="radio" value="N" name="excluirValidacoesVazias" formControlName="excluirValidacoesVazias"> Não
          </div>
        </div>
      </div>
    </div>
  </form>
  
</div>

<app-validacao-scr-listagem
  [validacoesScr]="validacoesScr"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  *ngIf="pesquisado"
  (aoMudarPagina)="mudancaPagina($event)"
  >
</app-validacao-scr-listagem>